/** Platform › Settings: the platform's defaults (staff only). */
export const PLATFORM_SETTINGS_PATH = '/platform/settings'
